import { FC } from 'react';
import { Skeleton } from 'antd';
import type { CollectionCardProps } from './index';
import * as Styled from './styles';

export const CollectionCardSkeleton: FC<
  Pick<CollectionCardProps, 'className' | 'width' | 'height'>
> = ({ className, width, height }) => {
  return (
    <Styled.Wrapper className={className} $height={height} $width={width}>
      <Styled.CardContent>
        <Skeleton.Image
          style={{
            maxHeight: '100%',
            objectFit: 'cover',
            width: '100%',
            height: '173px',
            borderRadius: 20
          }}
        />
      </Styled.CardContent>

      <Styled.Meta>
        <Styled.CollectionLogoWrapper>
          <Styled.CollectionLogo>
            <Skeleton.Avatar size={64} />
          </Styled.CollectionLogo>
        </Styled.CollectionLogoWrapper>
        <div className="artist-meta-info">
          <Skeleton.Button
            shape="round"
            active
            block
            style={{
              height: 16,
              margin: '2px 0',
              width: '60%'
            }}
          />
          <Skeleton.Button
            shape="round"
            active
            style={{
              height: 14,
              margin: '3px 0'
            }}
          />
        </div>
      </Styled.Meta>
    </Styled.Wrapper>
  );
};
